import { render, staticRenderFns } from "./TaskTypeBuildingOrder.vue?vue&type=template&id=20718efe"
import script from "./TaskTypeBuildingOrder.vue?vue&type=script&lang=js"
export * from "./TaskTypeBuildingOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports